import { LanguageProps } from './Language.types';

export const Language = ({ name, index }: LanguageProps) => <span>{index === 0 ? name : `, ${name}`}</span>;
